export default [
    {
        package: "Add-On Pkg #1",
        name: "Basic updates",
        id: 0,
        price: 50,
        info01: "* Update current pages as needed.",
        info02: "* Max of 10 pages with updates",
        info03: "* Add digital documents to existing notion workspace."
    },
    {
        package: "Add-on Pkg #2",
        name: "Digital Documents",
        id: 1,
        price: "20/document",
        info01: "* Create digital documents from printed ones",
        info02: "* Can be created as a pdf file or into a Notion page",
    },
    {
        package: "Add-on Pkg #3",
        name: "Additional new pages",
        id: 2,
        price: "30/page",
        info01: "* Create additional pages to new websites",
    },
    {
        package: "Add-on Pkg #4",
        name: "Simple SSL",
        id: 3,
        price: 50.00,
        info01: "* Create a SSL account through Cloudflare",
        info02: "* You MUST have root domain DNS access to add new settings.",
        info03: "* Will change DNS if login information for root domain is provided.",
    },
    {
        package: "Add-on Pkg #5",
        name: "Basic yearly maintenance",
        id: 4,
        price: "200/year",
        info01: "* Includes upkeep of yearly billed items - Domain name, Hosting, SSL",
        info02: "* Update page content quarterly as needed",
        info03: "* Max of 10 page websites.",
    },
];